import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import * as RSlider from '@radix-ui/react-slider';
import { useReader, useReaderChapters, useReaderLocation, useReaderProgress } from './reader.js';
function defaultLabel(i) {
    const parts = [];
    if (i.chapterCount > 1)
        parts.push(`Ch ${i.chapterIndex + 1}/${i.chapterCount}`);
    parts.push(`${Math.round(i.percent * 100)}%`);
    if (!i.dragging && i.minutesLeft > 0)
        parts.push(`${i.minutesLeft} min left`);
    return parts.join(' · ');
}
/**
 * A draggable progress bar bound to the reader position (Radix `Slider`, so
 * keyboard-seekable and labelled). Chapter tick marks, a live "Ch 3/12 · 47%"
 * label. Renders nothing until the book has more than one page.
 */
export function ReaderScrubber({ className, ticks = true, label, dir = 'ltr' }) {
    const loc = useReaderLocation();
    const progress = useReaderProgress();
    const chapters = useReaderChapters();
    const { goto } = useReader();
    const [drag, setDrag] = useState(null);
    if (!loc || loc.total <= 1)
        return null;
    const max = loc.total - 1;
    const page = Math.min(Math.max(drag ?? loc.page, 0), max);
    const dragging = drag !== null;
    let chapterIndex = 0;
    for (let i = 0; i < chapters.length; i++)
        if (chapters[i].startPage <= page)
            chapterIndex = i;
    const info = {
        page,
        total: loc.total,
        percent: max > 0 ? page / max : 0,
        chapterIndex,
        chapterCount: progress?.chapterCount ?? chapters.length,
        chapterLabel: chapters[chapterIndex]?.label ?? progress?.chapterLabel ?? '',
        minutesLeft: progress?.minutesLeft ?? 0,
        dragging,
    };
    return (_jsxs("div", { className: className ?? 'pore-scrubber', "data-pore-scrubber": true, children: [_jsxs(RSlider.Root, { className: "pore-scrubber__slider", "data-pore-scrubber-slider": true, dir: dir, min: 0, max: max, step: 1, value: [page], onValueChange: ([v]) => setDrag(v ?? 0), onValueCommit: ([v]) => {
                    if (v != null)
                        goto(v);
                    setDrag(null);
                }, "aria-label": "Seek through the book", children: [_jsx(RSlider.Track, { className: "pore-scrubber__track", "data-pore-scrubber-track": true, children: _jsx(RSlider.Range, { className: "pore-scrubber__range" }) }), ticks &&
                        chapters.map((c) => c.startPage > 0 && c.startPage < max ? (_jsx("span", { className: "pore-scrubber__tick", "data-pore-scrubber-tick": true, style: { left: `${(c.startPage / max) * 100}%` }, title: c.label, "aria-hidden": true }, c.id)) : null), _jsx(RSlider.Thumb, { className: "pore-scrubber__thumb", "aria-label": "Seek" })] }), label !== false && (_jsx("div", { className: "pore-scrubber__label", "data-pore-scrubber-label": true, "aria-live": "off", children: label ? label(info) : defaultLabel(info) }))] }));
}
//# sourceMappingURL=scrubber.js.map